import { createApi } from '@core/fetch'

export default {
  getMarketingIndex: createApi(
    '/p/wedding/index.php/admin/APIMarketingCenter/index'
  ),
  getMarketingIndexV2: createApi(
    '/p/wedding/index.php/admin/APIMarketingCenter/indexV2'
  ),
  fee: createApi.post('/p/wedding/index.php/admin/APIMerchantPro/pay_money'),
  getShopProductPrice: createApi(
    '/p/wedding/index.php/admin/APIMerchant/ShopProductPrice'
  ),
  getBuyInfo: createApi('/p/wedding/index.php/Admin/APIMerchant/buyProInfo'),

  // 获取五大价格
  getWuDaPrices: createApi('/p/wedding/Admin/APIMerchantPrice/price')
}
